import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.css']
})
export class DocumentationComponent {
  documents: any[] = [];

  constructor(private afs: AngularFirestore, private ngZone: NgZone, private cdr: ChangeDetectorRef) {
    this.afs.collection('general-documentation').valueChanges().subscribe((res: any) => {
      // Firebase puede emitir fuera de la zona de Angular → forzamos CD.
      this.ngZone.run(() => {
        if (res !== undefined && res !== null) {
          this.documents = res;
          console.log(this.documents);
        }
        this.cdr.detectChanges();
      });
    });
  }
}
